import 'css-chunk:src/app/containers/Home/CommunitiesView/CommunityDetailView/CommunityDetails.scss';export default {
  "CommunityDetails": "_CommunityDetails_hh876_1"
};